__turbopack_context__.v({
  "header": "CategoriesGrid-module-scss-module__jLM4EW__header",
  "heartWrapper": "CategoriesGrid-module-scss-module__jLM4EW__heartWrapper",
  "subtitle": "CategoriesGrid-module-scss-module__jLM4EW__subtitle",
  "tagGrid": "CategoriesGrid-module-scss-module__jLM4EW__tagGrid",
  "title": "CategoriesGrid-module-scss-module__jLM4EW__title",
  "wrapper": "CategoriesGrid-module-scss-module__jLM4EW__wrapper",
});
